// Unified research data: conference, workshop, preprint, poster & project work.
// `categories` controls which filter buttons a paper shows up under.
const publicationsData = [
  {
    id: 'uist-2026-demo',
    coverImage: 'asset/images/agentcube.jpeg',
    title: 'AgentCube: AI-Assisted In-Situ Authoring for Physical Computing',
    authors: ['Boyang Zhou', 'Jaewook Lee', 'Jon Froehlich'],
    venue: 'UIST',
    year: '2026 Demo',
    categories: ['selected', 'conference'],
    links: {
      pdf: 'https://doi.org/10.1145/3830397.3842474'
    },
    abstract: "Create, test, and iterate right at the deployment site"
  },
  {
    id: 'learn-to-match-2026',
    coverImage: 'asset/images/learn_to_match.png',
    title: 'Learn to Match: Two-Sided Matching with Temporally Extended Feedback',
    authors: [
      'Haijing Zong',
      'Yancheng Liang',
      'Boyang Zhou',
      'Natasha Jaques'
    ],
    venue: 'EC',
    year: "2026 Workshop: Online Learning and Economics",
    categories: ['selected', 'workshop'],
    links: {
      arxiv: 'https://arxiv.org/abs/2606.06744'
    }
  },
  {
    id: 'negative-commons',
    coverImage: 'asset/images/linux_workflow.png',
    title: 'Addressing Negative Commons Governance with Positive Commons Principles',
    authors: [
      'Boyang Zhou*',
      'Oleg Ianchenko*'
    ],
    collaborator: '(Special thanks to <a href="https://kurti.sh/" target="_blank" rel="noopener noreferrer">Kurtis Heimerl</a>)',
    venue: '12th Workshop on Computing within Limits',
    year: '2026',
    categories: ['workshop'],
    links: {
      arxiv: 'https://arxiv.org/abs/2606.04563'
    },
  },
  {
    id: 'heartbeatcam-2025',
    title: 'HeartbeatCam: Self-Triggered Photo Elicitation of Stress Events Using Wearable Sensing',
    authors: [
      'Boyang Zhou',
      'Zara Dana'
    ],
    venue: 'CHI',
    year: '2026 Workshop: Everyday Wearable for Personalized Health and Well-Being',
    categories: ['workshop'],
    coverImage: 'asset/images/heartbeatcam.png',
    links: { arxiv: 'https://arxiv.org/abs/2604.04314' },
    abstract: 'Using wearable sensing to support therapist guided reflection'
  },
  {
    id: 'glancear-2026',
    title: 'GlanceAR: Repurposing Phone Sensors via Low-Cost Reflectors for Always-On Obstacle Awareness',
    authors: [
      'Boyang Zhou',
      'Xizhe Hao',
      'Minbeom Kim',
      'Jaewook Lee',
      'Jon E. Froehlich'
    ],
    venue: 'preprint',
    year: '2026 (in submission)',
    categories: ['preprint'],
    coverImage: 'asset/images/agentcube_cover_photo.png',
    links: { arxiv: 'https://arxiv.org/abs/2610.33142' }
  },
  {
    id: 'generative-inbetweening-2025',
    title: 'Generative Inbetweening: Adapting Image-to-Video Models for Keyframe Interpolation',
    authors: [
      'Xiaojuan Wang',
      'Boyang Zhou',
      'Brian Curless',
      'Ira Kemelmacher-Shlizerman',
      'Aleksander Holynski',
      'Steven M. Seitz'
    ],
    venue: 'ICLR',
    year: '2025',
    categories: ['selected', 'conference'],
    coverImage: 'asset/videos/car_frame_interpolation.mp4',
    links: {
      webpage: 'https://svd-keyframe-interpolation.github.io/',
      arxiv: 'https://arxiv.org/abs/2408.15239',
      code: 'https://github.com/jeanne-wang/svd_keyframe_interpolation.git',
      demo: 'https://huggingface.co/spaces/fffiloni/svd_keyframe_interpolation',
      dataset: 'https://drive.google.com/file/d/1aOiQutnHKGNtt6eNlo-n5iSDfRMFqmk8/view?usp=drive_link'
    },
    abstract: 'How video diffusion models encode forward/backward temporal dynamics?'
  },
  {
    id: 'care-apple-vision-pro-2025',
    title: 'CARE - Clinician Augmented Reality Environment: Design and Technical Feasibility of Apple Vision Pro for Image-guided Surgeries',
    authors: [
      'Ze Xia Lucas Wang',
      'Marianny De León',
      'Boyang Zhou',
      'Sai Jayanth Kalisi',
      'Keith Meng Phou',
      'Jennifer Han',
      'Yijun Chen',
      'Alicia Betty',
      'Oliver Aalami',
      'Alberto Paderno',
      'Rania Hussein'
    ],
    venue: 'preprint',
    year: '2025',
    categories: ['preprint'],
    coverImage: 'asset/images/care-cover.jpg',
    links: {
      webpage: 'https://uw-care.github.io/',
      pdf: 'https://uw-care.github.io/static/papers/JAMIA_Paper__final_.pdf'
    },
    abstract: ''
  },
  {
    id: 'ttt-nn',
    coverImage: 'asset/images/tttnn-results.png',
    title: 'Reproducibility Report: Test-Time Training on Nearest Neighbors for Large Language Models',
    authors: [
      'Boyang Zhou',
      'Johan Lindqvist',
      'Lindsey Li'
    ],
    collaborator: '(Special thanks to <a href="https://mrtz.org/" target="_blank" rel="noopener noreferrer">Moritz Hardt</a> and <a href="https://yueatsprograms.github.io/" target="_blank" rel="noopener noreferrer">Yu Sun</a>)',
    venue: 'arXiv',
    tag: ['Machine Learning', 'NLP'],
    year: '2025',
    categories: ['preprint'],
    links: {
      arxiv: 'https://arxiv.org/abs/2511.16691'
    },
    abstract: ''
  },
  // {
  //   id: 'vr-6dof',
  //   coverImage: 'asset/images/forest_first_frame.jpeg',
  //   title: 'mono6D: Online 6-DOF Viewer - Transforming Casually Captured 360° Video into On-The-Go 6-DOF Immersive Experiences',
  //   authors: ['Boyang Zhou'],
  //   collaborator: '(Special thanks to <a href="https://ana-serrano.github.io/" target="_blank" rel="noopener noreferrer">Ana Serrano</a> and <a href="https://www.linkedin.com/in/dlanman" target="_blank" rel="noopener noreferrer">Douglas Lanman</a>)',
  //   venue: 'Course project',
  //   tag: ['Graphics', 'XR'],
  //   year: '2024',
  //   categories: ['project'],
  //   links: {
  //     demo: 'https://mono6d-a0ee0.web.app/',
  //     webpage: 'https://boezzz.com/mono6D'
  //   }
  // }
  // {
  //   id: 'so-arm100',
  //   coverImage: 'asset/images/base_anchor.jpg',
  //   title: 'Droi-Link: Real-Time Sensor Sharing for Enhancing Human-Robot Collaboration',
  //   authors: ['Boyang Zhou', 'Yu-Jung Su', 'Shas Mani'],
  //   venue: '',
  //   tag: ['Robotics', 'XR'],
  //   year: '2025',
  //   categories: ['poster'],
  //   links: {
  //     poster: 'asset/images/droi-link-poster.jpg'
  //   },
  //   abstract: 'A novel human-robot collaboration system that leverages head-mounted XR devices as mobile sensing platforms for robotic manipulation tasks.'
  // },
  // {
  //   id: 'ar-esi',
  //   coverImage: 'asset/images/spine.png',
  //   title: 'AR Guidance for Pain Medicine Spine Injections',
  //   authors: ['Barbara Kozminski', 'John Akers', 'Zezhong Yang', 'Boyang Zhou'],
  //   venue: '',
  //   tag: ['Health', 'XR'],
  //   year: '2022',
  //   categories: ['poster'],
  //   links: {
  //     poster: 'asset/images/aresi_poster.png'
  //   },
  //   abstract: 'Augmented reality guidance system for epidural steroid injection procedures in pain medicine.'
  // }
];

// Filter buttons shown above the list, in display order.
// `all` is special and matches everything; any other `key` matches papers
// whose `categories` array includes that key. To add a category later,
// add an entry here and tag the relevant papers above with the same key.
// Available category keys: selected, conference, workshop, preprint, project, poster.
export const publicationFilters = [
  { key: 'all', label: 'All' },
  { key: 'selected', label: 'Selected' }
  // e.g. { key: 'conference', label: 'Conference' },
  //      { key: 'workshop', label: 'Workshop' },
  //      { key: 'preprint', label: 'Preprints' }
];

// `all` matches everything; any other key matches a publication's `categories`.
export const matchesFilter = (publication, key) =>
  key === 'all' || (publication.categories || []).includes(key);

export default publicationsData;
